const API_MISSION_FIELDS = [
    'mission.translations.mission_title',
    'mission.translations.mission_text',
    'mission.image'
];
const API_TEAM_FIELDS = [
    'team.translations.team_title',
    'team.translations.right_text',
    'team.translations.left_text',
    'team.translations.president_text'
];
const API_STRATEGY_FIELDS = [
    'strategy.image',
    'strategy.translations.strategy_title',
    'strategy.translations.strategy_text',
    'strategy.strategy_items.strategy_items_id.translations.strategy_title',
    'strategy.strategy_items.strategy_items_id.translations.strategy_text'
];
const API_DIGITAL_GROW_FIELDS = [
    'digitalgrow.assistance_metrics.digital_grow_metrics_id.value',
    'digitalgrow.assistance_metrics.digital_grow_metrics_id.translations.unit',
    'digitalgrow.assistance_metrics.digital_grow_metrics_id.translations.name',
    'digitalgrow.formation_metrics.digital_grow_metrics_id.value',
    'digitalgrow.formation_metrics.digital_grow_metrics_id.translations.unit',
    'digitalgrow.formation_metrics.digital_grow_metrics_id.translations.name',
    'digitalgrow.translations.title',
    'digitalgrow.translations.formation_title',
    'digitalgrow.translations.map_image',
    'digitalgrow.translations.assistance_title',
    'digitalgrow.projects.project_id.image_color',
    'digitalgrow.projects.project_id.translations.name',
    'digitalgrow.projects.project_id.translations.header_image_data_text'
];
const API_OBJECTIVES_FIELDS = [
    'objectives.translations.title',
    'objectives.translations.text',
    'objectives.translations.image',
    'objectives.items.objectives_items_id.number',
    'objectives.items.objectives_items_id.color',
    'objectives.items.objectives_items_id.translations.title',
    'objectives.items.objectives_items_id.translations.image'
];
const API_ANNUAL_REPORT_FIELDS = [
    'annual_report.translations.title',
    'annual_report.annual_report_items.translations.url',
    'annual_report.annual_report_items.translations.title',
    'annual_report.annual_report_items.translations.file'
];
export { API_MISSION_FIELDS, API_TEAM_FIELDS, API_STRATEGY_FIELDS, API_DIGITAL_GROW_FIELDS, API_OBJECTIVES_FIELDS, API_ANNUAL_REPORT_FIELDS };
